import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button } = wp.components;
const { useState } = wp.element;

export default ({ attributes, setAttributes, className }) => {
  const [localMediaTestimonialOne, setLocalMediaTestimonialOne] = useState(attributes.url_1);
  const [localMediaTestimonialTwo, setLocalMediaTestimonialTwo] = useState(attributes.url_2);

  const handleOnSelectImageTestimonialOne = ( media ) => {
    setAttributes({ url_1: media.url });
    setLocalMediaTestimonialOne( media.url );
  };
  
  const handleOnChangeNameTestimonialOne = ( name_1 ) => {
    setAttributes({ name_1 });
  };

  const handleOnChangeSubtitleTestimonialOne = ( subtitle_1 ) => {
    setAttributes({ subtitle_1 });
  };

  const handleOnChangeDescriptionTestimonialOne = ( description_1 ) => {
    setAttributes({ description_1 });
  };

  const handleOnSelectImageTestimonialTwo = ( media ) => {
    setAttributes({ url_2: media.url });
    setLocalMediaTestimonialTwo( media.url );
  };
  
  const handleOnChangeNameTestimonialTwo = ( name_2 ) => {
    setAttributes({ name_2 });
  };

  const handleOnChangeSubtitleTestimonialTwo = ( subtitle_2 ) => {
    setAttributes({ subtitle_2 });
  };

  const handleOnChangeDescriptionTestimonialTwo = ( description_2 ) => {
    setAttributes({ description_2 });
  };

  return(
    <div className={ className }>
      <div className="wrapper">
        <InnerBlocks 
        template={[ ['core/heading'] ]}
        templateLock="all"
        />

        <div className="testimonial">
          <div className="testimonial__info">
            <div className="testimonial__logo">
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={handleOnSelectImageTestimonialOne}
                  allowedTypes={["image"]}
                  render={({ open }) => (
                    <>
                      <Button
                        className="SelectImage"
                        onClick={open}
                      >
                      {__("Selecionar Logo", "block")}
                      </Button>
                    </>
                  )}
                />
              </MediaUploadCheck>
              
              <img src={localMediaTestimonialOne} />
            </div>
            
            <div className="testimonial__description">
              <div className="testimonial__stars">
                <img src="./../wp-content/themes/wpensar/assets/blocks/images/five-stars.png"/>
              </div>

              <RichText
              tagName="span"
              className="testimonial__name"
              placeholder={__("Nome")}
              value={attributes.name_1}
              onChange={handleOnChangeNameTestimonialOne}
              />

              <RichText
              tagName="span"
              className="testimonial__subtitle"
              placeholder={__("Cargo")}
              value={attributes.subtitle_1}
              onChange={handleOnChangeSubtitleTestimonialOne}
              />
            </div>
          </div>

          <div className="testimonial__testimonial">
            <RichText
              tagName="p"
              className=""
              placeholder={__("Escreva o Depoimento")}
              value={attributes.description_1}
              onChange={handleOnChangeDescriptionTestimonialOne}
            />
          </div>
        </div>

        <div className="testimonial">
          <div className="testimonial__info">
            <div className="testimonial__logo">
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={handleOnSelectImageTestimonialTwo}
                  allowedTypes={["image"]}
                  render={({ open }) => (
                    <>
                      <Button
                        className="SelectImage"
                        onClick={open}
                      >
                      {__("Selecionar Logo", "block")}
                      </Button>
                    </>
                  )}
                />
              </MediaUploadCheck>
              
              <img src={localMediaTestimonialTwo} />
            </div>
            
            <div className="testimonial__description">
              <div className="testimonial__stars">
                <img src="./../wp-content/themes/wpensar/assets/blocks/images/five-stars.png"/>
              </div>

              <RichText
              tagName="span"
              className="testimonial__name"
              placeholder={__("Nome")}
              value={attributes.name_2}
              onChange={handleOnChangeNameTestimonialTwo}
              />

              <RichText
              tagName="span"
              className="testimonial__subtitle"
              placeholder={__("Cargo")}
              value={attributes.subtitle_2}
              onChange={handleOnChangeSubtitleTestimonialTwo}
              />
            </div>
          </div>

          <div className="testimonial__testimonial">
            <RichText
              tagName="p"
              className=""
              placeholder={__("Escreva o Depoimento")}
              value={attributes.description_2}
              onChange={handleOnChangeDescriptionTestimonialTwo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
